import { useDispatch } from 'react-redux';
import Warning from '../assets/images/WarningOctagon.png'
import { fetchFoodCategories } from '../redux/slices/categoriesSlice';
import { toast } from 'react-toastify';
import { DeleteCategories } from '../services/addCategoryServices';
import { useEffect } from 'react';

export default function ConfirmDeleteCategor({isOpen, onClose, item}) {
  const dispatch = useDispatch();
  useEffect(() =>{
    dispatch(fetchFoodCategories())
  }, [dispatch])

  const deleteFn = async () => {
    if (item && item.id) {
      try {
        const res = await DeleteCategories(item.id);
        if (res.statusCode === 200) {
          toast.success();
          dispatch(fetchFoodCategories());
          onClose();
        } else if(res?.statusCode === 404){
          toast.error(res.message)
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to delete category. Please try again.");
      }
    } else {
      toast.error("Invalid category data. Unable to delete.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal fixed inset-0 bg-orange/20 backdrop-blur-[1px] grid place-items-center">
      <div className='bg-white rounded-2xl py-5 px-4 max-w-md'>
        <div className=" flex justify-center rounded-full">
          <img src={Warning} alt="" className='bg-[#eec4c4] rounded-full' />
        </div>
        <div className='mt-5'>
          <h2 className="text-4xl text-primaryRed text-center">Confirm Delete</h2>
          <div>
            <p class="text-center py-4">
              Are you sure you want to Delete this category?
            </p>
          </div>
          <div className='flex items-center justify-center gap-x-6 mt-5'>
            <button className="text-primaryRed border border-[#FFB0B0] px-6 py-2 text-center rounded-md w-full hover:bg-[#FFB0B0]" onClick={onClose}>Cancel</button>
            <button className="text-white border border-primryRed bg-primaryRed px-6 py-2 text-center rounded-md hover:bg-primaryRed/80 w-full"  onClick={deleteFn}>
            Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
